import { Callout } from '@/components/Callout/Callout';
import { FileCard } from '@/components/FileCard/FileCard';
import type { FileListRow } from '@/graphql/files';

import styles from './FileGrid.module.css';

export interface FileGridProps {
  files: FileListRow[];
  loading?: boolean;
  error?: string | null;
  onOpen: (fileId: string) => void;
  onDelete?: (fileId: string) => void;
  /** Ids deleted in this session, and any per-file failure, keyed by file id. */
  deletedIds?: ReadonlySet<string>;
  deletingId?: string | null;
  deleteErrors?: ReadonlyMap<string, string>;
}

export function FileGrid({
  files,
  loading = false,
  error = null,
  onOpen,
  onDelete,
  deletedIds,
  deletingId = null,
  deleteErrors,
}: FileGridProps) {
  if (error) {
    return (
      <Callout tone="danger" title="Keystone request failed">
        {error}
      </Callout>
    );
  }

  if (!files.length) {
    return (
      <p className={`${styles.empty} ${loading ? styles.loading : ''}`} role="status">
        {loading ? 'Asking Keystone…' : 'No files match these filters.'}
      </p>
    );
  }

  return (
    <ul aria-busy={loading} className={styles.grid}>
      {files.map((file) => (
        <FileCard
          deleteError={deleteErrors?.get(file.id) ?? null}
          deleted={deletedIds?.has(file.id) ?? false}
          deleting={deletingId === file.id}
          file={file}
          key={file.id}
          onDelete={onDelete}
          onOpen={onOpen}
        />
      ))}
    </ul>
  );
}
